module.exports = __webpack_public_path__ + "img/btn-close.ef2ca49b.svg";